import AlbumFolderJoinCode from './AlbumFolderJoinCode';

export default AlbumFolderJoinCode;
